import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getlanguages } from '../../../services/actions/MainAction';
import { changeStateValue } from '../../../services/redux/MainReducer';
import { useNavigate } from 'react-router-dom';

function ChangeLang() {
    const languages = useSelector(state => state.Data.languages);
    const langPrefix = useSelector(state => state.Data.langPrefix);
    const lang_id = useSelector(state => state.Data.lang_id);
    const navigate = useNavigate()
    const dispatch = useDispatch();
    useEffect(()=>{
        dispatch(getlanguages());

        let path = window.location.href;
        let prefix =langPrefix;
        let new_lang_id =lang_id;
        if(path.includes(".az/ru") || path.includes("01/ru")){
            prefix = "ru/";
            new_lang_id = 3;
        }else if(path.includes(".az/en") || path.includes("01/en")){
            prefix = "en/";
            new_lang_id = 2;
        }else if(path.includes(".az/tr") || path.includes("01/tr")){
            prefix = "tr/";
            new_lang_id = 4;
        }else{
            prefix = "";
            new_lang_id = 1;
        }
        dispatch(changeStateValue({name:"new_lang_id", value: lang_id}));
        dispatch(changeStateValue({name:"langPrefix", value: prefix}));
    },[]);
    const onChangeLang=(lang_id)=>{
        dispatch(changeStateValue({
            name:"lang_id",
            value: lang_id
          }))
        let prefix = langPrefix;
        if(lang_id==1){
          prefix="";
        }else if(lang_id == 2){
          prefix = "en/";
        }else if(lang_id == 3){
          prefix = "ru/";
        }else if(lang_id == 4){
          prefix = "tr/";
        }
        dispatch(changeStateValue({ name: "langPrefix", value: prefix }));
    
        // this.setState({langVisible:false});
        let path = window.location.pathname;
        let newPath = path
        if(path.includes("ru/")){
          newPath = path.replace("ru/", prefix)
        }else if(path.includes("en/")){
          newPath = path.replace("en/", prefix)
        }else if(path.includes("tr/")){
          newPath = path.replace("tr/", prefix)
        }else{
          newPath = prefix+path.replace("/",'')
        }
        navigate(`${newPath?.substring(0,1)==="/"?newPath:`/${newPath}`}`)
        
    }
    
  return (
    <div className='flex flex-col gap-[7px] max-[1100px]:flex-row'>
      {
        languages?.map((data, i)=>{
            return(
                <button onClick={()=>onChangeLang(data?.id)} className={`border border-white text-[12px] p-[1px_7px] ${lang_id === data?.id ? "bg-white text-[--red]":"text-white"} rounded-[4px]`} key={i}>{data?.title}</button>
            )
        })
      }
    </div>
  )
}

export default ChangeLang
